<!-- src/components/Dashboard/DashboardCard.vue -->
<template>
  <div class="dashboard-card">
    <div class="icon-container" :style="{ backgroundColor: props.cor }">
      <!-- Aqui o ícone deve aparecer se "props.icone" for, por exemplo, "bi-chat-dots" -->
      <i :class="['bi', props.icone]"></i>
    </div>
    <div class="content-container">
      <div class="card-number">{{ props.valor }}</div>
      <div class="card-title">{{ props.titulo }}</div>
      <div class="card-subtitle" :style="{ color: props.cor }">
        {{ props.subtitulo }}
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  titulo:     { type: String, required: true },
  subtitulo:  { type: String, default: '' },
  valor:      { type: [Number, String], required: true },
  cor:        { type: String, default: '#ffffff' },
  icone:      { type: String, default: 'bi-bar-chart-fill' }
});
</script>

<style scoped>
.dashboard-card {
  display: flex;
  width: 100%;
  height: 77px;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.icon-container {
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-container i {
  font-size: 1.5rem;    /* aumenta o tamanho do ícone */
  color: #ffffff;
}
.icon-container,
.icon-container i {
  cursor: inherit;
}

.content-container {
  flex: 1;
  padding: 0.75rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.card-number {
  font-size: 1.3rem;
  font-weight: 600;
  color: #333333;
  margin-bottom: 0rem;
}
.card-title {
  font-size: 0.85rem;
  color: #555555;
}
.card-subtitle {
  font-size: 0.7rem;
  margin-top: 0.1rem;
  line-height: 1.2;
}
</style>
